// extracted by mini-css-extract-plugin
export var Button = "styles-module--Button--4b2a1";
export var CTA = "styles-module--CTA--dbb22";
export var ColLeft = "styles-module--ColLeft--64a0d";
export var ColRight = "styles-module--ColRight--cf2ae";
export var FeaturedPost = "styles-module--FeaturedPost--93624";